import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@rebass/grid';
import ReactGA from 'react-ga';
import { Button } from 'app/ui_components/tags';
import { isMobile } from 'app/helpers/utils';
import { signupEndpoint } from 'app/helpers/api';
import animate from 'app/helpers/animations/cta';

const Container = styled(Box).attrs({
  ml: 'auto',
  width: [1 / 1, 1 / 6],
})`
  text-align: right;
  ${isMobile &&
    `
    z-index: 999;
    position: fixed;
    bottom:0;
    left: 0;
    left: 0;
    right: 0;
    width: 100vw;
    button{
      border-radius:0;
    }
  `};
`;

class CTA extends React.Component {
  static propTypes = {
    isStaff: PropTypes.bool.isRequired,
    sales_link: PropTypes.string,
    funnelType: PropTypes.string,
    usFoods: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isStaff: false,
    usFoods: false,
  };

  /* Ocular Assessment */
  // Determine which section the user is currently looking at
  // https://www.youtube.com/watch?v=9nuLZ929QiA
  ocularAssesment = () => {
    const middleEl = document.elementFromPoint(
      window.innerWidth / 2,
      window.innerHeight / 2,
    );

    // check element then recursively check its parents
    const check = el => {
      return el.className.toString().indexOf('sectionContainer') > -1
        ? el.id
        : check(el.parentElement);
    };

    return check(middleEl);
  };

  redirect = e => {
    const currentSection = this.ocularAssesment();
    ReactGA.event({
      category: 'Results',
      action: 'Click',
      label: 'optimize-nav',
    });
    ReactGA.event({
      category: 'Results',
      action: 'Click',
      label: `section-${currentSection}`,
    });
    const isSelfSignup = this.props.funnelType === 'self-signup';
    let destination = signupEndpoint(isSelfSignup);
    // Handle Saleslink URL params
    const params = new URLSearchParams(window.location.search);
    if (params.has('saleslink') && this.props.sales_link) {
      // Use validated sales_link from props to prevent XSS
      destination = this.props.sales_link
    }
    window.location = destination;
  };

  showCalendlyLink = e => {
    const { sales_link } = this.props;
    const link = `${
      window.location.href
    }&saleslink=${sales_link}&utm_source=sales&utm_medium=calendly`;

    alert(
      `Share this URL to include your Calendly link in this Report: ${link}`,
    );
  };

  componentDidMount() {
    animate();
  }

  render() {
    const { isStaff, usFoods } = this.props;
    const buttonTextForLead = usFoods ? 'Learn More' : 'Optimize';
    return (
      <Container id="topCTA">
        <Button onClick={isStaff ? this.showCalendlyLink : this.redirect} green>
          {isStaff ? 'Create Link' : buttonTextForLead}
        </Button>
      </Container>
    );
  }
}

const mapStateToProps = ({
  grade: { staff_request: isStaff, sales_link },
  funnelType,
  usFoods,
}) => ({
  isStaff,
  sales_link,
  funnelType,
  usFoods,
});

export default connect(
  mapStateToProps,
  null,
)(CTA);
